import { render, staticRenderFns } from "./PT640OrderChangeBannerHtmlParts.vue?vue&type=template&id=003adfe8&"
import script from "./PT640OrderChangeBannerHtmlParts.vue?vue&type=script&lang=js&"
export * from "./PT640OrderChangeBannerHtmlParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports